var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.41605C2 8.04665 2.18802 7.7001 2.50457 7.48603L10.3046 2.21117C10.7209 1.92961 11.2791 1.92961 11.6954 2.21117L19.4954 7.48603C19.812 7.70011 20 8.04665 20 8.41605V18.2882C20 19.2336 19.1941 20 18.2 20H3.8C2.80589 20 2 19.2336 2 18.2882V8.41605Z",
    stroke: "#505050",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.2c19293b002d2bd0c32b06a7af5c643c.svg";
export { ForwardRef as ReactComponent };